import { Stack } from '@fluentui/react';

export const NoAccess = () => (
  <Stack horizontalAlign="center" tokens={{ childrenGap: 16 }}>
    <h3>No Access</h3>
    <p>You are not authorized to access H2O Drive in this workspace.</p>
    <p>Please contact your administrator to request access.</p>
  </Stack>
);
